import React from 'react';
import I18n from 'i18n-js';
import SanitizedRender from './sanitized_render';
import { RCPopover } from '@reverbdotcom/cadence/components';
import { RCIcon } from '@reverbdotcom/cadence/components';
import { InfoCircleIcon } from '@reverbdotcom/cadence/icons/react';
import { useIsMobileWindowWidth } from '@reverbdotcom/cadence/components/helpers/is-mobile';
import { REVERB_BUMP } from '../url_helpers';

export function BumpDSACompliancePopover() {
  const position = useIsMobileWindowWidth() ? 'bottom-start' : 'right';

  return (
    <div className="mb-2 mt-1">
      <RCPopover
        position={position}
        anchor={
          <button className="button-as-link ml-half d-flex gap-1">
            <span className="color-secondary size-fixed-90">
              {I18n.t('discovery.bump.DSACompliancePopover.title')}
            </span>
            <span className="color-secondary size-fixed-100">
              <RCIcon svgComponent={InfoCircleIcon} inline />
            </span>
            <span className="visually-hidden">{I18n.t('discovery.bump.DSACompliancePopover.learnMore')}</span>
          </button>
        }
      >
        <SanitizedRender
          htmlTag="span"
          html={I18n.t('discovery.bump.DSACompliancePopover.description', {
            linkOpen: `<a href="${REVERB_BUMP}" target=_blank class="text-link" rel="nofollow">`,
            linkClose: '</a>',
          })}
        />
      </RCPopover>
    </div>
  );
}
